import {
  MonarchTestHook,
  MonarchTestResult,
} from "@/monarch/useMonarchTestResult";

export const SEARCH_FYP_PLACEMENTS = [
  "before-filters",
  "after-abandoned-cart",
  "before-results",
  "after-results",
  "inline-results",
] as const;

export type SearchFypPlacement = (typeof SEARCH_FYP_PLACEMENTS)[number];

export const SearchFypPlacementId: Record<string, SearchFypPlacement> = {
  BeforeFilters: "before-filters",
  AfterAbandonedCart: "after-abandoned-cart",
  BeforeResults: "before-results",
  AfterResults: "after-results",
  InlineResults: "inline-results",
} as const;

export type SearchFypEntryVariant = "control" | "test";

export type SearchFypInlineSection =
  | "after-programs"
  | "after-courses"
  | "after-executive-education"
  | "after-degrees";

export type SearchFypInlineConfig = {
  /** First page: render after which LOB section */
  firstPagePosition?: SearchFypInlineSection;
  /** Tab page: render after the Nth card row (1-based). Adapts to grid columns per breakpoint. */
  tabPagePosition?: number;
};

export type SearchFypEntryData = {
  isVisible?: boolean;
  placement?: SearchFypPlacement;
  forcedFlowId?: string;
  jumpToStepId?: string;
  styleVariant?: "default" | "alt";
  /** Position config only used when placement is "inline-results" */
  inlineConfig?: SearchFypInlineConfig;
};

export type SearchFypEntryTestResult = MonarchTestResult<
  SearchFypEntryVariant,
  SearchFypEntryData
>;

export type UseSearchFypEntry = MonarchTestHook<
  SearchFypEntryVariant,
  SearchFypEntryData
>;
